type LabelledUser = {
  id: number;
  first_name?: string | null;
  last_name?: string | null;
  email: string;
};

/** Full name when we have both parts, email otherwise. */
export function formatUserLabel(user: LabelledUser) {
  return user.first_name && user.last_name
    ? `${user.first_name} ${user.last_name}`
    : user.email;
}

/**
 * Owner dropdown/filter options, sorted by label. Shared so the owner cell,
 * the tables that hoist the list out of their rows, and the wishlist's owner
 * filter all agree on how a user is labelled.
 */
export function buildOwnerOptions(
  authorizations: { user: LabelledUser }[],
): { value: number; label: string }[] {
  return authorizations
    .map(({ user }) => ({ value: user.id, label: formatUserLabel(user) }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
